import React from "react";
import "./about.css";
import { Youtube, Rocket, Repeat, BookOpen, Users, Wrench, Globe, GraduationCap, ArrowRightCircle } from "lucide-react";

const timeline = [
  {
    year: "2019",
    title: "Compartilhando aulas de circuitos online",
    icon: <Youtube size={26} />,
    image: "/about_20190912_085828.jpg",
    paragraphs: [
      "Em 2019, no antigo Canal do Elétron, o Prof. Nicholas Yukio começou a produzir e compartilhar aulas online de circuitos elétricos, como uma extensão de seu ensino presencial no ITA.",
    ],
  },
  {
    year: "2020",
    title: "Domínio Elétrico v1",
    icon: <Rocket size={26} />,
    image: "/about_20201207.png",
    paragraphs: [
      "Em janeiro de 2020, lançamos a primeira versão do curso de circuitos numa plataforma terceirizada. Tinha apenas 6 módulos, mas foi a primeira prova concreta do valor do nosso trabalho de ensino online.",
    ],
  },
  {
    year: "2021",
    title: "Aumentando a base de alunos",
    icon: <Repeat size={26} />,
    image: "/about_20200330.png",
    paragraphs: [
      "Era o auge da pandemia, e as dificuldades do sistema de ensino tradicional das faculdades de engenharia ficaram ainda mais evidentes. Chegamos à casa de centenas de alunos estudando conosco.",
    ],
  },
  {
    year: "2022",
    title: "Aulas experimentais",
    icon: <BookOpen size={26} />,
    image: "/about_20221215.jpg",
    paragraphs: [
      "Fizemos investimentos relevantes em infraestrutura de laboratório de circuitos eletrônicos para produzir o DE Labs, que é a parte de aulas experimentais, mostrando o funcionamento de circuitos em laboratório.",
    ],
  },
  {
    year: "2023",
    title: "Expandindo a comunidade",
    icon: <Users size={26} />,
    image: "/about_20230108.jpg",
    paragraphs: [
      "A esta altura, o Domínio Elétrico já estava bem mais completo: 11 módulos, DE Labs, curso de matemática básica para circuitos, orientações de estudos e muito material pdf para consulta.",
    ],
  },
  {
    year: "2024",
    title: "Mudança de plataforma",
    icon: <Wrench size={26} />,
    image: "/playlist_experimentos_thumbnail.jpg",
    paragraphs: [
      "Buscando melhor compromisso entre custo e funcionalidades, migramos entre algumas plataformas de terceiros para hospedagem dos nossos cursos.",
    ],
  },
  {
    year: "2025",
    title: "Site Domínio Elétrico",
    icon: <Globe size={26} />,
    image: "/screenshots/screenshot_04.jpg",
    paragraphs: [
      "Depois de constatar que nenhuma plataforma comercial abarcava todas as necessidades e pretensões do projeto Domínio Elétrico, desenvolvemos a nossa própria com poucas funcionalidades inicialmente.",
    ],
  },
  {
    year: "2026",
    title: "Um ambiente completo de aprendizagem",
    icon: <GraduationCap size={26} />,
    image: "/about_20260721.png",
    paragraphs: [
      "Hoje, o Domínio Elétrico é muito mais que um curso: é um ambiente completo de aprendizagem para estudantes de engenharia elétrica e eletrônica.",
    ],
  },
];

function About() {
  return (
    <main className="de-about">
      {/* HERO */}
      <section
        className="de-about-hero"
        style={{
          backgroundImage:
            "radial-gradient(ellipse 45% 55% at 50% 45%, rgba(255, 255, 255, 0.85) 0%, rgba(255, 255, 255, 0.35) 70%, rgba(255, 255, 255, 0) 100%), url(/about_hero_bg.jpg)",
        }}
      >
        <div className="de-about-hero-inner">
          {/* <span className="de-about-badge">Nossa história</span> */}
          <h1 className="de-about-title">
            A história do <span>Domínio Elétrico</span>
          </h1>
          <p className="de-about-subtitle">
            De aulas livres de circuitos elétricos a um ambiente completo de aprendizagem para
            estudantes de engenharia. Conheça nossa história.
          </p>
        </div>
      </section>

      {/* LINHA DO TEMPO (imagem full-width com texto sobreposto) */}
      <section className="de-about-timeline">
        {timeline.map((item) => (
          <article
            key={item.year}
            className="de-about-year"
            style={{ backgroundImage: `url(${item.image})` }}
          >
            <div className="de-about-overlay" />
            <div className="de-about-content">
              <span className="de-about-year-tag">{item.year}</span>
              <div className="de-about-heading">
                <span className="de-about-icon">{item.icon}</span>
                <h2>
                  <span className="de-about-hl">{item.title}</span>
                </h2>
              </div>
              {item.paragraphs.map((paragraph, i) => (
                <p key={i}>
                  <span className="de-about-hl">{paragraph}</span>
                </p>
              ))}
            </div>
          </article>
        ))}
      </section>

      {/* CTA FINAL */}
      <section className="de-about-cta">
        <div className="de-about-cta-inner">
          <h2>Faça parte dessa história</h2>
          <p>
            Junte-se a centenas de estudantes que já dominam circuitos elétricos
            com o Domínio Elétrico. O próximo capítulo pode ser o seu.
          </p>
          <a href="/premium" className="de-about-cta-button">
            Quero ser aluno <ArrowRightCircle size={20} />
          </a>
        </div>
      </section>
    </main>
  );
}

export default About;
